import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ExpandedPanelHistoryService {
  public currentStateOfPanels = new BehaviorSubject<ExpandedPanelHistoryEntry[]>([]);


}

export interface ExpandedPanelHistoryEntry{
  url: string;
  index: number;
}
